<template>
  <div>
    <AdminNav />
    <main class="page">
      <header class="page-header">
        <div>
          <h2 class="page-title">Entreprise</h2>
          <p class="subtitle">Paramètres entreprise, mentions facture et accès comptables admin.</p>
        </div>
        <button class="btn btn-primary" @click="enregistrer" :disabled="loading">{{ loading ? 'Enregistrement...' : 'Enregistrer' }}</button>
      </header>

      <p class="success-message" v-if="message">{{ message }}</p>
      <p class="error-message" v-if="erreur">{{ erreur }}</p>
      <p class="notice" v-if="apiIndisponible">Paramètres entreprise à connecter à l’API.</p>

      <section class="quick-links">
        <router-link to="/admin/comptabilite-micro">Comptabilité micro</router-link>
        <router-link to="/admin/justificatifs">Justificatifs</router-link>
        <router-link to="/admin/gestion-financiere">Pilotage financier</router-link>
        <router-link to="/admin/facturation">Facturation</router-link>
      </section>

      <section class="panel">
        <div class="panel-head">
          <h3>Informations entreprise</h3>
          <span class="badge">Admin</span>
        </div>
        <div class="grid">
          <label class="field">Nom commercial<input v-model="form.nom_commercial" class="input" /></label>
          <label class="field">Nom légal<input v-model="form.nom_legal" class="input" /></label>
          <label class="field">Statut juridique<input v-model="form.statut_juridique" class="input" /></label>
          <label class="field">SIRET<input v-model="form.siret" class="input" /></label>
          <label class="field">Email<input v-model="form.email" class="input" type="email" /></label>
          <label class="field">Téléphone<input v-model="form.telephone" class="input" /></label>
          <label class="field">Site web<input v-model="form.site_web" class="input" /></label>
        </div>
        <label class="field">Adresse<textarea v-model="form.adresse" class="input textarea"></textarea></label>
      </section>

      <section class="panel">
        <div class="panel-head">
          <h3>Mentions facture</h3>
        </div>
        <div class="grid">
          <label class="field">Mention TVA<input v-model="form.mention_tva" class="input" /></label>
          <label class="field">Délai paiement par défaut
            <input v-model.number="form.delai_paiement_defaut" class="input" type="number" min="0" />
          </label>
          <label class="field">Mode règlement par défaut
            <select v-model="form.mode_reglement_defaut" class="input">
              <option>À définir</option>
              <option>Virement bancaire</option>
              <option>Espèces</option>
              <option>Carte bancaire</option>
              <option>Chèque</option>
              <option>Prélèvement</option>
              <option>Autre</option>
            </select>
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">
          <h3>Réglages par défaut</h3>
        </div>
        <div class="grid">
          <label class="field">IBAN<input v-model="form.iban" class="input" /></label>
          <label class="field">BIC<input v-model="form.bic" class="input" /></label>
        </div>
        <label class="field">Notes<textarea v-model="form.notes" class="input textarea"></textarea></label>
      </section>
    </main>
  </div>
</template>

<script>
import AdminNav from '../../components/AdminNav.vue'
import adminApi from '../../adminApi'

export default {
  name: 'AdminEntrepriseParametres',
  components: { AdminNav },
  data() {
    return {
      loading: false,
      erreur: '',
      message: '',
      apiIndisponible: false,
      form: this.parametresDefaut()
    }
  },
  methods: {
    parametresDefaut() {
      return {
        nom_commercial: 'Fidmarket',
        nom_legal: 'Matéo DAVENEAU',
        statut_juridique: 'Entrepreneur individuel (EI)',
        siret: '',
        adresse: '',
        email: 'contact@fidmarket.fr',
        telephone: '',
        site_web: 'fidmarket.fr',
        mention_tva: 'TVA non applicable, art. 293 B du CGI',
        delai_paiement_defaut: 0,
        mode_reglement_defaut: 'À définir',
        iban: '',
        bic: '',
        notes: ''
      }
    },
    async charger() {
      this.erreur = ''
      try {
        const res = await adminApi.get('/entreprise/parametres')
        this.form = { ...this.parametresDefaut(), ...(res.data || {}) }
        this.apiIndisponible = false
      } catch (err) {
        this.apiIndisponible = true
        this.erreur = err.response?.data?.error || 'Impossible de charger les paramètres entreprise.'
      }
    },
    async enregistrer() {
      this.loading = true
      this.erreur = ''
      this.message = ''
      try {
        const res = await adminApi.put('/entreprise/parametres', this.form)
        this.form = { ...this.parametresDefaut(), ...(res.data || {}) }
        this.apiIndisponible = false
        this.message = 'Paramètres entreprise enregistrés.'
      } catch (err) {
        this.apiIndisponible = true
        this.erreur = err.response?.data?.error || 'Impossible d’enregistrer les paramètres entreprise.'
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.charger()
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
}
.page-header, .quick-links, .grid {
  display: grid;
  gap: 12px;
}
.page-header {
  margin-bottom: 14px;
}
.page-title {
  margin: 0 0 4px;
  color: #1a202c;
  font-size: 22px;
  font-weight: 700;
}
.subtitle {
  margin: 0;
  color: #718096;
  font-size: 13px;
  line-height: 1.4;
}
.quick-links {
  grid-template-columns: 1fr;
  margin-bottom: 14px;
}
.quick-links a {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #edf2f7;
  color: #2d3748;
  text-decoration: none;
  font-weight: 700;
}
.panel {
  min-width: 0;
  margin-bottom: 14px;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.panel-head h3 {
  margin: 0;
  color: #2d3748;
  font-size: 16px;
}
.field {
  display: grid;
  gap: 6px;
  margin-bottom: 12px;
  color: #718096;
  font-size: 12px;
  font-weight: 700;
}
.input {
  width: 100%;
  min-height: 40px;
  padding: 9px 11px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  box-sizing: border-box;
}
.textarea {
  min-height: 88px;
  resize: vertical;
}
.btn {
  min-height: 40px;
  padding: 10px 14px;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-primary { background: #2d3748; color: white; }
.badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  border-radius: 999px;
  padding: 4px 10px;
  background: #e8f1fd;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
}
.success-message, .error-message, .notice {
  padding: 10px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
}
.success-message { color: #22543d; background: #c6f6d5; }
.error-message { color: #742a2a; background: #fed7d7; }
.notice { color: #2d3748; background: #f7fafc; font-weight: 700; }

@media (min-width: 720px) {
  .page { padding: 24px; }
  .page-header {
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
  }
  .quick-links {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
